import { Box, CardMedia, CircularProgress, Icon, InputAdornment, Typography } from '@mui/material'
import AdxInput from 'components/custom/AdxInput'
import AdxPagination from 'components/custom/AdxPagination'
import PerfSortTable from 'components/reusable/table/PerfSortTable'
import React, { useEffect, useRef, useState } from 'react'
import { useMutation } from 'react-query'
import defaultImage from 'assets/images/default_avatar.png'
import { getTeamParticipants } from 'services/api/modules/performance/appraisal/participants'
import PTMDrawer from './PTMDrawer'

const PTeamMembers = ({ managerId, appraisalId }) => {
  const inputEl = useRef('')
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState('')

  const {
    isLoading,
    data,
    mutate: getParticipants,
  } = useMutation((values) => getTeamParticipants(managerId, appraisalId, currentPage, values), {
    onSuccess: async () => {},
  })

  useEffect(() => {
    let newSearch = {}
    newSearch = {
      search: searchTerm,
    }
    setTimeout(() => {
      getParticipants(newSearch)
    }, 1000)
  }, [currentPage, searchTerm])

  const participants = data?.data?.data

  const employeeColumn = [
    {
      Header: 'Employee',
      accessor: 'name',
      Cell: (props) => {
        const { value } = props
        return (
          <Box display="flex" alignItems="center" justifyContent="flex-start">
            <Box sx={{ position: 'relative' }}>
              <CardMedia
                component="img"
                sx={{
                  height: 40,
                  width: 40,
                  objectFit: 'cover',
                  borderRadius: '50%',
                  marginRight: 2,
                }}
                src={props?.row?.original?.profile_image || defaultImage}
              />
            </Box>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="space-around"
              alignItems="flex-start"
            >
              <Typography>{value}</Typography>
              <Typography variant="body2" sx={{ color: 'light-gray-text.main' }}>
                {props?.row?.original?.designation}
              </Typography>
            </Box>
          </Box>
        )
      },
    },
    {
      Header: 'Score',
      accessor: 'total_score', // sorting is based on accessor value, if string then A-Z. If number small - large
      Cell: (props) => {
        const { value } = props

        return (
          <Box>
            <Typography>{value ? Math.round(value * 50) / 10 : '--'}</Typography>
          </Box>
        )
      },
    },
  ]

  const getSearchTerm = (e) => {
    setSearchTerm(e.target.value)
  }

  // Drawer function
  const [staff, setStaff] = useState([])
  const [drawerState, setDrawerState] = useState({ right: false })
  const handleDrawer = (anchor, open) => (item) => {
    setDrawerState({ ...drawerState, [anchor]: open })
    setStaff(item)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: '100vh - 200px',
        rowGap: 4,
      }}
    >
      <Box
        sx={{
          width: '70%',
          display: 'flex',
          alignItems: { xs: null, sm: 'center' },
          justifyContent: 'space-between',
          flexDirection: { xs: 'column', sm: 'row' },
          rowGap: 1,
          padding: 0.2,
        }}
      >
        <AdxInput
          sx={{
            width: { xs: 1, sm: 4 / 6 },
            '& .MuiInputBase-root': {
              outline: 'none',
              bgcolor: 'white.main',
            },
          }}
          value={searchTerm}
          ref={inputEl}
          onChange={getSearchTerm}
          startAdornment={
            <InputAdornment position="start">
              <Icon>search</Icon>
            </InputAdornment>
          }
          placeholder="Search employee name"
        />
      </Box>

      {isLoading && (
        <Box height="30vh" display="flex" justifyContent="center" alignItems="center">
          <CircularProgress color="alternate" size={60} />
        </Box>
      )}
      {!isLoading && (
        <Box sx={{ width: '100%' }}>
          <PerfSortTable
            column={employeeColumn}
            data={participants ?? []}
            nav="View"
            onClick={handleDrawer('right', true)}
            sxNav={{ textDecoration: 'underline' }}
            sxCell
            sx={{ boxShadow: 'none' }}
          />

          {data?.data?.meta?.last_page > 1 ? (
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              py={1}
              backgroundColor="white.main"
            >
              <AdxPagination
                count={data?.data?.meta?.last_page}
                onChange={(event, page) => setCurrentPage(page)}
                defaultPage={currentPage}
              />
            </Box>
          ) : null}
        </Box>
      )}
      <PTMDrawer
        drawerState={drawerState}
        handleDrawer={handleDrawer}
        staff={staff}
        appraisalId={appraisalId}
      />
    </Box>
  )
}

export default PTeamMembers
